import moment from "moment"

export const getDate = (day: string) =>
  day ? moment(day).utc().format("YYYYMMDD") : ""
